import { render, staticRenderFns } from "./config_quota_signal.vue?vue&type=template&id=740edd74&scoped=true"
import script from "./config_quota_signal.vue?vue&type=script&lang=js"
export * from "./config_quota_signal.vue?vue&type=script&lang=js"
import style0 from "./config_quota_signal.vue?vue&type=style&index=0&id=740edd74&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740edd74",
  null
  
)

export default component.exports